import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import CautionFace from 'components/ui/AnimatedStates/CautionFace';
import SuccessFace from 'components/ui/AnimatedStates/SuccessFace';
import LoadingFace from 'components/ui/AnimatedStates/LoadingFace';
import ErrorFace from 'components/ui/AnimatedStates/ErrorFace';

const STATES = {
  confirm: 'confirm',
  error: 'error',
  success: 'success',
  loading: 'loading',
};

const ConfirmationDialog = ({
  showConfirmationDialog,
  dialogState,
  confirm,
  success,
  loading,
  error,
}) => (
  <Dialog
    disableBackdropClick
    open={showConfirmationDialog}
    classes={{
      paper: 'form-dialog',
    }}
    style={{ zIndex: 3000 }}
  >
    {dialogState === STATES.confirm && (
      <CautionFace
        buttonText={confirm.primaryBtnText}
        headerText={confirm.headerText}
        onClick={confirm.primaryAction}
        bodyText={confirm.bodyText}
        onSecondaryClick={confirm.secondaryAction}
        secondaryButtonText={confirm.secondaryBtnText}
      />
    )}
    {dialogState === STATES.success && (
      <SuccessFace
        buttonText={success.primaryBtnText}
        headerText={success.headerText}
        onClick={success.action}
        bodyText={success.bodyText}
      />
    )}
    {dialogState === STATES.loading && (
      <LoadingFace headerText={loading.headerText} bodyText={loading.bodyText} />
    )}
    {dialogState === STATES.error && (
      <ErrorFace
        buttonText={error.primaryBtnText}
        headerText={error.headerText}
        bodyText={error.bodyText}
        onClick={error.action}
      />
    )}
  </Dialog>
);

export default ConfirmationDialog;
